import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import AppBar from "@mui/material/AppBar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Categories from "./components/Categories";
import Intro from "./components/Intro";
import Invest from "./components/Invest";
import Commitment from "./components/Commitment";
import Image from "../../assets/banner/ai.jpg";
import Banner from "./components/Banner";
import Selection from "./components/Selection";
import WhoWillFund from "./components/WhoWillFund";

const styles = {
  paperContainer: {
    height: 300,
    backgroundImage: `linear-gradient(rgba(57,72,78,0.5),rgba(57,72,78,0.5)), url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Grantees = () => {
  return (
    <Box>
      <Helmet>
        <title>
          {" "}
          For Grantees | The African Innovation and Resilience Fund
        </title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        sx={{
          backgroundColor: "#fff",
          padding: "10px 0px",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
          <Header />
        </Container>
      </AppBar>
      <Box style={styles.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box bgcolor={"#fff"}>
        <Container>
          <Intro />
        </Container>
      </Box>
      <Box bgcolor={"#fff"}>
        <Container>
          <Invest />
        </Container>
      </Box>
      <Box bgcolor={"#fff"}>
        <Container>
          <WhoWillFund />
        </Container>
      </Box>
      <Box bgcolor={"#F6F4F0"}>
        <Container>
          <Categories />
        </Container>
      </Box>
      <Box bgcolor={"#fff"}>
        <Container>
          <Selection />
        </Container>
      </Box>
      <Box bgcolor={"#F6F4F0"}>
        <Container>
          <Commitment />
        </Container>
      </Box>
      <Box bgcolor={"#39484E"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Grantees;
